import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { clearCart } from '../redux/reducers/cartSlice';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Alert from 'react-bootstrap/Alert';
import MenuPrincipal from '../components/menuPrincipal';
import { useNavigate } from 'react-router-dom';
import '../style/checkout.css'
import { AiOutlineCheckCircle } from 'react-icons/ai'; // Importando ícone de sucesso
import { QrCodePix } from "qrcode-pix";
import iconePix from "../../src/assets/imagens/icons8-pix-100.png";
import api from '../redux/actions/configApi';
import Rodape from "../components/rodape";
import { scrollToTop } from '../util';
import { emailConfirmacaoVenda } from '../redux/reducers/vendasSlice'; // Importa o thunk
import WhatsApp from "../components/whatsApp";

const Checkout = () => {

    const [qrCode, setQrCode] = useState('');
    const [end, setEnd] = useState('');
    const [horario, setHorario] = useState([]);
    const [rawPix, setRawPix] = useState('');
    const [currentStep, setCurrentStep] = useState(1);
    const [timeLeft, setTimeLeft] = useState(300); // 5 minutos para pagamento via Pix (300 segundos)
    const [isPaymentProcessing, setIsPaymentProcessing] = useState(false); // Controle de repetição de pagamento
    const { products, totalAmount, deliveryMethod } = useSelector((state) => state.cart);
    const [errorMessage, setErrorMessage] = useState(''); // Estado para mensagens de erro
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const topRefCh = useRef(null);
    // Gerencia o avanço de cada etapa
    const handleNextStep = async () => {
        scrollToTop(topRefCh)
        if (currentStep === 2) {
            await savePaymentData();
        } else {
            setCurrentStep(currentStep + 1);
        }
    };
    const handlePreviousStep = () => {
        scrollToTop(topRefCh)
        if (currentStep > 1) setCurrentStep(currentStep - 1);
    };

    // Temporizador para o pagamento via Pix
    useEffect(() => {
        if (currentStep === 2 && timeLeft > 0) {
            const timer = setInterval(() => setTimeLeft(prevTime => prevTime - 1), 1000);
            return () => clearInterval(timer);
        }
    }, [currentStep, timeLeft]);

    useEffect(() => {
        if (timeLeft === 0) {
            setTimeLeft(300); // Resetar o timer se o tempo acabar
        }
    }, [timeLeft]);

    // Formata o tempo restante no cronômetro
    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
    };
    // Função para calcular o CRC16
    useEffect(() => {
        async function generateDynamicPix() {
            const qrCodePix = QrCodePix({
                version: '01',
                key: 'contato@pentalobe.com.br',
                name: 'Pentalobe',
                city: 'Blumenau SC',
                transactionId: '1213221',
                // message: 'Recebidos da semana??? 😂',
                value: totalAmount,
            })

            const rawPixStr = qrCodePix.payload()
            const qrCodeBase64 = await qrCodePix.base64()

            setRawPix(rawPixStr)
            setQrCode(qrCodeBase64)
        }

        void generateDynamicPix();
    }, [totalAmount])

    useEffect(() => {
        const enderecoSalvo = localStorage.getItem('endereco');
        if (enderecoSalvo) {
            const enderecoObj = JSON.parse(enderecoSalvo);
            setEnd(enderecoObj);
            console.log('Endereço armazenado:', enderecoObj);
        }
        const horario = localStorage.getItem('horarios');
        if (enderecoSalvo) {
            const horarioObj = JSON.parse(horario);
            setHorario(horarioObj);
            console.log('Horario armazenado:', horarioObj);
        }

    }, [totalAmount])


    const savePaymentData = async () => {
        if (!isPaymentProcessing) {
            setIsPaymentProcessing(true); // Bloqueia novas tentativas de pagamento
            try {
                const response = await api.post('orders', {
                    products,
                    totalAmount,
                    payment_method: 'Pix',
                    deliveryMethod: 'Retirada na Loja'
                    // rawPix
                });
                let order_code = response.data.order_code;
                if (response.data.success) {

                    dispatch(emailConfirmacaoVenda({ order_code }));
                    setCurrentStep(3); // Avança para o próximo passo de conclusão da compra
                    sessionStorage.setItem('checkout_completed', 'true');
                    dispatch(clearCart()); // <-- Limpa o carrinho aqui
                    scrollToTop(topRefCh)
                } else {
                    console.error('Erro na confirmação do pagamento:', response.data.message);
                }
            } catch (error) {
                if (error.response) {
                    const { data } = error.response;

                    // Se for erro de autenticação
                    if (data.codigo === 401) {
                        navigate('/checkout');
                    }
                    // Se for erro de regra de negócio vindo do Laravel (ex.: estoque insuficiente)
                    else if (data.error) {
                        setErrorMessage(data.error);
                    }
                    // Fallback genérico
                    else {
                        setErrorMessage("Erro inesperado. Tente novamente.");
                    }

                } else {
                    setErrorMessage("Erro de conexão. Verifique sua internet.");
                }

                console.error('Erro no envio do pagamento:', error);
            } finally {
                setIsPaymentProcessing(false); // Desbloqueia o botão após o envio
            }
        }
    };

    useEffect(() => {
        if (currentStep === 3) {
            sessionStorage.removeItem('checkout_completed');
        }
    }, [currentStep]);

    return (
        <div>
            <MenuPrincipal />
            <div className='section-spacing-4' ref={topRefCh}>
                <Row >
                    <Col xs={12} md={12} lg={12} className='progress-bar-2'>
                        <ProgressBar now={(currentStep / 3) * 100} label={`Passo ${currentStep} de 3`} className="custom-progress-bar mb-4" />
                    </Col>
                </Row>
                {/* Conteúdo por etapa */}
                <div className="checkout-container">
                    {currentStep === 1 && (
                        <div>
                            <h2 className="step-title"><i style={{ color: '#E79800' }} class="fa-regular fa-rectangle-list"></i> Resumo da Compra</h2>
                            <Row>
                                {/* Coluna do resumo dos itens */}
                                <Col xs={12} md={6}>
                                    <div className="store-info">
                                        <h4 className="section-title-2">
                                            <i className="fas fa-shopping-cart icon"></i> Resumo dos Itens
                                        </h4>
                                        {products.map((item) => (
                                            <div key={item.id} className="cart-item">
                                                <div className="item-details">
                                                    <p><strong>Produto:</strong> {item.name}</p>
                                                    <p><strong>Preço Unitário:</strong> <span style={{ color: '#E79800', fontWeight: 'bold' }}>{Number(item.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span></p>
                                                    <p><strong>Quantidade:</strong> {item.quantity}</p>
                                                    <strong>Total:</strong> <span style={{ color: '#E79800', fontWeight: 'bold' }}>{(item.price * item.quantity).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                                                </div>
                                            </div>
                                        ))}
                                        <div className="order-total">
                                            <p><i style={{ color: '#E79800', fontWeight: 'bold' }} className="fas fa-money-bill-wave icon"></i> <strong>Valor Total:</strong> <span style={{ color: '#E79800', fontWeight: 'bold' }}>{totalAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span></p>
                                        </div>
                                    </div>
                                </Col>
                                {/* Coluna do endereço da loja */}
                                <Col xs={12} md={6}>
                                    <div className="store-info">
                                        <div style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', padding: '20px' }}>
                                            <h4 className="section-title-2">
                                                <i className="fas fa-store icon"></i> Local de Retirada
                                            </h4>
                                            <div className="store-address">
                                                <p ><strong>Endereço:</strong> {end}</p>
                                                {/*<p><strong>Telefone:</strong> (11) 1234-5678</p>*/}
                                                <p ><strong>Horário de Atendimento:</strong>
                                                </p>
                                                {horario?.map((horario, index) => (
                                                    <p key={index}>{horario}</p>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    )}
                    {currentStep === 2 && (
                        <div className="checkout-step">
                            <h2 className="step-title"><i style={{ color: '#E79800' }} class="fa-regular fa-rectangle-list"></i> Forma de Pagamento</h2>
                            {errorMessage && (
                                <Alert className='text-center' variant="danger" onClose={() => setErrorMessage('')} dismissible>
                                    {errorMessage}
                                </Alert>
                            )}
                            <div className='checkout-step-box'>
                                <h4><img className='icone-pix' src={iconePix} /> Pix</h4>
                                <div className="pix-info">
                                    <p>Escaneie o QR Code ou copie o código Pix para pagamento:</p>
                                    <img src={qrCode} alt={'QR Code PIX'} />
                                    <p style={{ fontSize: '20px' }}><strong>Valor:</strong> <span style={{ color: '#E79800' }}><strong>{totalAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong></span></p>
                                    <p
                                        style={{
                                            maxWidth: '480px',
                                            margin: '0 auto',
                                            whiteSpace: 'nowrap',
                                            overflow: 'auto'
                                        }}
                                    >
                                        {rawPix}
                                    </p>

                                </div>
                            </div>
                        </div>
                    )}
                    {currentStep === 3 && (
                        <div className="checkout-step">
                            <h2 className="step-title"><i style={{ color: '#E79800' }} class="fa-solid fa-check"></i> Conclusão da Compra</h2>
                            <div className='checkout-step-box text-conclusao'>
                                <AiOutlineCheckCircle className="success-icon" />
                                <p>Obrigado pela sua compra! 😄</p>
                                <p>A confirmação será enviada ao seu e-mail.</p>
                                <p>Você também pode acompanhar todas as informações através do painel 😄</p>
                            </div>
                        </div>
                    )}
                    <div className='d-flex justify-content-center'>
                        <div className="checkout-navigation mt-4 mb-4">
                            {currentStep < 3 ? (
                                <div className='d-flex justify-content-center'>
                                    <div className='finalize-purchase text-center'>
                                        <Button className="me-2">
                                            <a onClick={handlePreviousStep} style={{ color: '#fff', textDecoration: 'none' }} >Voltar</a>
                                        </Button>
                                    </div>

                                    <div className={`${currentStep === 2 ? 'finalize-purchase-2' : 'finalize-purchase'} text-center`}>
                                        <Button onClick={handleNextStep}>
                                            {currentStep === 2 ? 'Finalizar Pagamento' : 'Próximo'}
                                        </Button>
                                    </div>
                                </div>
                            ) : (
                                <div className='finalize-purchase text-center'>
                                    <a href='/dashboard'>
                                        <Button >
                                            Ir para o Painel
                                        </Button>
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Rodape />
             <WhatsApp classe={'whatsapp-componente-flutuante outra-posicao'}/>
        </div>
    );
};

export default Checkout;
